import { useState, useId } from 'react';
import clsx from 'clsx';
import Button from '../Button';

type TimeFramesProps<T extends string> = {
    onTimeframeChange: (newValue: T) => void;
    timeframes: T[];
    defaultTimeframe?: T;
};

const TimeFrames = <T extends string>({
    timeframes,
    defaultTimeframe,
    onTimeframeChange,
}: TimeFramesProps<T>) => {
    const uuid = useId();

    const [selectedTimeframe, setSelectedTimeframe] = useState<T>(
        defaultTimeframe ?? timeframes[0]
    );

    const handleClick = (timeframe: T) => {
        onTimeframeChange(timeframe);
        setSelectedTimeframe(timeframe);
    };

    return (
        <div
            className='timeframes-radio'
            role='radiogroup'
            aria-labelledby={`${uuid}-timeframe`}
        >
            <div id={`${uuid}-timeframe`} className='visually-hidden'>
                Time Frame
            </div>
            {timeframes.map((item, index) => {
                const isChecked = item === selectedTimeframe;

                return (
                    <Button
                        key={index}
                        role='radio'
                        variant='tertiary'
                        aria-checked={isChecked}
                        aria-label={item}
                        onClick={!isChecked ? () => handleClick(item) : undefined}
                        className={clsx({ active: isChecked })}
                        tabIndex={isChecked ? -1 : 0}
                    >
                        {item}
                    </Button>
                );
            })}
        </div>
    );
};

export default TimeFrames;
